export const GET_CUSTOMER_COUNT = "GET_CUSTOMER_COUNT"
export const GET_CUSTOMER_COUNT_ERR = "GET_CUSTOMER_COUNT_ERR"
